import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "niceDateFormatPipe",
  standalone: true,
})
export class niceDateFormatPipe implements PipeTransform {
  curDate: Date;
  constructor(private translateService: TranslateService) {}

  transform(value: string, curDate: Date) {
    this.curDate = curDate;

    var _value = Number(value);

    var dif = Math.floor((this.curDate.getTime() - _value) / 1000 / 86400);

    if (dif < 30) {
      return this.convertToNiceDate(value);
    } else {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, "dd/MM/yy");
      return value;
    }
  }

  convertToNiceDate(time: string) {
    var date = new Date(time),
      diff = (this.curDate.getTime() - date.getTime()) / 1000,
      daydiff = diff / 86400;

    if (isNaN(daydiff) || daydiff < 0) return "";

    let today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    let isYesterday = yesterday.toDateString() == date.toDateString();

    return (
      (daydiff < 1 &&
        !isYesterday &&
        ((diff < 60 && this.translateService.instant("dateDiff.justNow")) ||
          (diff < 120 && this.translateService.instant("dateDiff.1min")) ||
          (diff < 3600 &&
            this.translateService.instant("dateDiff.minutes", {
              val: Math.floor(diff / 60),
            })) ||
          (diff < 7200 && this.translateService.instant("dateDiff.1hr")) ||
          (diff < 86400 &&
            this.translateService.instant("dateDiff.hrs", {
              val: Math.floor(diff / 3600),
            })))) ||
      (isYesterday &&
        this.translateService.instant("dateDiff.yesterday") +
          " " +
          new DatePipe("en-US").transform(Number(time), "HH:mm")) ||
      (daydiff < 3 &&
        this.translateService.instant("dateDiff.beforeYesterday")) ||
      (daydiff < 7 &&
        this.translateService.instant("dateDiff.days", {
          val: Math.floor(daydiff),
        })) ||
      (daydiff < 31 &&
        this.translateService.instant("dateDiff.weeks", {
          val: Math.floor(daydiff / 7),
        }))
    );
  }
}
